export * from './lib/ui-template.module';
